import {createSlice} from "@reduxjs/toolkit";

const initialCustomersState = {
  listLoading: false,
  totalCount: 0,
  entities: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const bankCardsSlice = createSlice({
  name: "bankCards",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
        state.entities = [];
        state.totalCount = 0;
      } else {
        state.actionsLoading = true;
      }
    },
    bankCardsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    licenseUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    }
  }
});
